import React from 'react';

const Privacy = () => {
  return (
    <div className="main">
      <div className="container">
        <div className="legal-content">
          <h1>Privacy Policy</h1>
          
          <div className="legal-highlight-box">
            <p><strong>Your Privacy Matters:</strong> At CHALYATI, we are committed to protecting your personal information and respecting your privacy. This policy explains how we collect, use, and safeguard your data when you use our car rental services.</p>
          </div>
          
          <h2>1. Information We Collect</h2>
          <p>We collect various types of information to provide and improve our car rental services:</p>
          <ul>
            <li><strong>Personal Information:</strong> Name, email address, phone number, date of birth</li>
            <li><strong>Identity Documents:</strong> Driver's license details, government-issued ID</li>
            <li><strong>Payment Information:</strong> Credit card details, billing address</li>
            <li><strong>Rental History:</strong> Booking details, vehicle preferences, rental patterns</li>
            <li><strong>Technical Data:</strong> IP address, browser type, device information</li>
          </ul>
          
          <div className="legal-section-divider"></div>
          
          <h2>2. How We Use Your Information</h2>
          <p>Your personal information is used for the following purposes:</p>
          <ul>
            <li>Processing and managing rental bookings</li>
            <li>Verifying identity and conducting background checks</li>
            <li>Facilitating secure payments and transactions</li>
            <li>Providing customer support and assistance</li>
            <li>Sending booking confirmations and service updates</li>
            <li>Improving our services and user experience</li>
            <li>Compliance with legal and regulatory requirements</li>
          </ul>
          
          <h2>3. Information Sharing and Disclosure</h2>
          <div className="legal-highlight-box">
            <p><strong>We Never Sell Your Data:</strong> We do not sell, trade, or rent your personal information to third parties for marketing purposes.</p>
          </div>
          <p>We may share your information only in the following circumstances:</p>
          <ul>
            <li><strong>Service Providers:</strong> Trusted partners who assist in service delivery</li>
            <li><strong>Legal Requirements:</strong> When required by law or legal process</li>
            <li><strong>Safety and Security:</strong> To protect our users and prevent fraud</li>
            <li><strong>Business Transfers:</strong> In case of merger, acquisition, or asset sale</li>
          </ul>
          
          <div className="legal-section-divider"></div>
          
          <h2>4. Data Security Measures</h2>
          <p>We implement comprehensive security measures to protect your personal information:</p>
          <ul>
            <li>SSL encryption for all data transmissions</li>
            <li>Secure servers with regular security updates</li>
            <li>Access controls and employee training programs</li>
            <li>Regular security audits and vulnerability assessments</li>
            <li>PCI DSS compliance for payment processing</li>
          </ul>
          <p>However, no method of internet transmission is 100% secure. We cannot guarantee absolute security but continuously work to enhance our protective measures.</p>
          
          <h2>5. Cookies and Tracking Technologies</h2>
          <p>Our website uses cookies and similar technologies to enhance your browsing experience:</p>
          <ul>
            <li><strong>Essential Cookies:</strong> Required for website functionality</li>
            <li><strong>Performance Cookies:</strong> Help us analyze website traffic</li>
            <li><strong>Functional Cookies:</strong> Remember your preferences</li>
            <li><strong>Marketing Cookies:</strong> Deliver relevant advertisements</li>
          </ul>
          <p>You can control cookie settings through your browser preferences, though this may affect website functionality.</p>
          
          <div className="legal-section-divider"></div>
          
          <h2>6. Third-Party Services</h2>
          <p>We work with trusted third-party service providers for various functions:</p>
          <ul>
            <li><strong>Payment Processors:</strong> Secure transaction handling</li>
            <li><strong>Analytics Services:</strong> Website performance monitoring</li>
            <li><strong>Communication Tools:</strong> Customer support platforms</li>
            <li><strong>Mapping Services:</strong> Location and navigation features</li>
          </ul>
          <p>These services have their own privacy policies and data handling practices, which we encourage you to review.</p>
          
          <h2>7. Data Retention Policy</h2>
          <p>We retain your personal information for different periods based on the type of data:</p>
          <ul>
            <li><strong>Account Information:</strong> Until account deletion or 3 years of inactivity</li>
            <li><strong>Rental Records:</strong> 7 years for tax and legal compliance</li>
            <li><strong>Payment Data:</strong> As required by financial regulations</li>
            <li><strong>Marketing Data:</strong> Until you opt out or withdraw consent</li>
          </ul>
          
          <div className="legal-section-divider"></div>
          
          <h2>8. Your Privacy Rights</h2>
          <div className="legal-highlight-box">
            <p><strong>You Have Control:</strong> You have several rights regarding your personal information, and we're committed to helping you exercise them.</p>
          </div>
          <p>Your rights include:</p>
          <ul>
            <li><strong>Access:</strong> Request copies of your personal data</li>
            <li><strong>Correction:</strong> Update or correct inaccurate information</li>
            <li><strong>Deletion:</strong> Request removal of your personal data</li>
            <li><strong>Portability:</strong> Obtain your data in a structured format</li>
            <li><strong>Objection:</strong> Object to certain processing activities</li>
            <li><strong>Restriction:</strong> Limit how we process your data</li>
          </ul>
          
          <h2>9. International Data Transfers</h2>
          <p>Your personal information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place through:</p>
          <ul>
            <li>Adequacy decisions by relevant authorities</li>
            <li>Standard contractual clauses</li>
            <li>Binding corporate rules</li>
            <li>Certification schemes and codes of conduct</li>
          </ul>
          
          <h2>10. Children's Privacy</h2>
          <p>Our services are not intended for individuals under 21 years of age. We do not knowingly collect personal information from minors. If we become aware that we have collected data from a child, we will take steps to delete such information promptly.</p>
          
          <div className="legal-section-divider"></div>
          
          <h2>11. Marketing Communications</h2>
          <p>We may send you marketing communications about our services, special offers, and promotions. You can:</p>
          <ul>
            <li>Opt out at any time using unsubscribe links</li>
            <li>Update your communication preferences in your account</li>
            <li>Contact us directly to modify your preferences</li>
          </ul>
          <p>Even if you opt out of marketing communications, we may still send you service-related messages.</p>
          
          <h2>12. Legal Basis for Processing</h2>
          <p>We process your personal information based on various legal grounds:</p>
          <ul>
            <li><strong>Consent:</strong> When you explicitly agree to processing</li>
            <li><strong>Contract:</strong> To fulfill our rental service obligations</li>
            <li><strong>Legal Obligation:</strong> To comply with applicable laws</li>
            <li><strong>Legitimate Interest:</strong> For business operations and improvements</li>
          </ul>
          
          <div className="legal-section-divider"></div>
          
          <h2>13. Data Breach Response</h2>
          <p>In the unlikely event of a data breach that may affect your personal information:</p>
          <ul>
            <li>We will assess the risk and impact immediately</li>
            <li>Notify relevant authorities within 72 hours (where required)</li>
            <li>Inform affected users without undue delay</li>
            <li>Take immediate steps to contain and remediate the incident</li>
            <li>Provide guidance on protective measures you can take</li>
          </ul>
          
          <h2>14. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. When we make material changes:</p>
          <ul>
            <li>We will post the updated policy on our website</li>
            <li>Update the "Last Modified" date</li>
            <li>Notify you via email or platform notifications</li>
            <li>Obtain new consent where legally required</li>
          </ul>
          
          <h2>15. Contact Us About Privacy</h2>
          <p>If you have questions about this Privacy Policy or how we handle your personal information, please don't hesitate to contact us. We're here to help and ensure your privacy concerns are addressed promptly.</p>
          
          <div className="legal-contact-info">
            <h3>Privacy Contact Information</h3>
            <p>For privacy-related inquiries and requests:</p>
            <p><strong>Privacy Email:</strong> privacy@chalyati.com</p>
            <p><strong>General Email:</strong> support@chalyati.com</p>
            <p><strong>Phone:</strong> +91 80996 62446</p>
            <p><strong>WhatsApp:</strong> +91 80996 62446</p>
            <p><strong>Address:</strong> CHALYATI Car Rentals, India</p>
          </div>
          
          <div className="legal-last-updated">
            <p><strong>Last updated:</strong> December 2024</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;